var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 3.4375C-4.29688 4.46875 -4.29688 50.5312 27.5 51.5625C59.2969 50.5312 59.2969 4.46875 27.5 3.4375Z",
    fill: "#007738"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.734 20.4538L24.0621 37.1256C23.3746 37.8131 22.3433 37.8131 21.6558 37.1256L14.2652 29.735C12.7183 28.1881 15.1246 25.7819 16.6715 27.3288L22.859 33.5163L38.3277 18.0475C39.8746 16.3288 42.2808 18.9069 40.734 20.4538Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmark);
export default __webpack_public_path__ + "static/media/green-checkmark.1539eff948f2087db9138bbca2b704ed.svg";
export { ForwardRef as ReactComponent };